<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลโครงการ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text mb-3">
            1. หลักการและเหตุผล
            <div class="theme-color-seven txt-normal" style="text-indent: 16px">
              (ระบุที่มาและความสำคัญของการดำเนินโครงการแสดงรายละเอียดข้อมูลของปัญหาที่ผู้ประกอบการต้องการพัฒนา
              และปรับปรุงประสิทธิภาพ และผลลัพธ์ที่คาดว่าจะได้รับจากการนําเทคโนโลยี องค์ความรู้
              และความช่วยเหลือของคณะผู้เชี่ยวชาญเข้าไปแก้ไขปัญหาและพัฒนากิจการ
              เพิ่มประสิทธิภาพของกิจการของผู้ประกอบการ ชี้แจง รายละเอียดโดยย่อ)
            </div>
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  :value="form.principle"
                  @onChange="setFormField('principle', $event)"
              ></TextArea>
            </div>
          </div>
        </div>

      </div>
    </divcard>

    <!-- 2. วัตถุประสงค์ -->
    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            2. วัตถุประสงค์ (ระบุข้อมูลที่ใช้วัดผลความสำเร็จเมื่อเสร็จโครงการ
            แสดงทั้งในรูปแบบของเชิงปริมาณและคุณภาพให้มีความสอดคล้องกับ วัตถุประสงค์ของโครงการ)
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  :value="form.objective"
                  @onChange="setFormField('objective', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!-- 3. กลุ่มเป้าหมายในพื้นที่ (Demand side) -->
    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            3. กลุ่มเป้าหมายในพื้นที่ (Demand side)
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
              </div>
              <TextArea
                  theme="3"
                  :value="form.demand"
                  @onChange="setFormField('demand', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>
      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
            </div>
            <TextArea
                theme="3"
                :value="form.marketing"
                @onChange="setFormField('marketing', $event)"
            ></TextArea>
          </div>
        </div>
      </div>

    </divcard>

    <!-- 4. ขั้นตอนและขอบเขตการดำเนินโครงการ -->
    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            4. ขั้นตอนและขอบเขตการดำเนินโครงการ
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  :value="form.scope"
                  @onChange="setFormField('scope', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!-- 5. ศักยภาพและความพร้อมในการดำเนินโครงการของอุทยานวิทยาศาสตร์ภูมิภาค -->
    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            5. ศักยภาพและความพร้อมในการดำเนินโครงการของอุทยานวิทยาศาสตร์ภูมิภาค
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ความพร้อมของห้องปฏิบัติการ/อุปกรณ์ที่มีอยู่เดิมในการให้บริการภาคเอกชน
              </div>
              <Wysiwyg
                  theme="3"
                  :value="form.lab_ready"
                  @onChange="setFormField('lab_ready', $event)"
              ></Wysiwyg>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              แผนการเสริมศักยภาพอุปกรณ์และสิ่งอำนวยความสะดวก
            </div>
            <Wysiwyg
                theme="3"
                :value="form.tools_enhance"
                @onChange="setFormField('tools_enhance', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ความสะดวกและรวดเร็วในการให้บริการ รวมถึงมีความสะดวกในการเข้าถึงและเชื่อมโยงกับบริการของหน่วยงานอื่น
              (เชื่อมโยงกับกงสี)
            </div>
            <Wysiwyg
                theme="3"
                :value="form.convenient"
                @onChange="setFormField('convenient', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              แนวทางการพัฒนาบุคลากร และความรู้ความสามารถของบุคลากรผู้ให้บริการ
            </div>
            <Wysiwyg
                theme="3"
                :value="form.improve_officer"
                @onChange="setFormField('improve_officer', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ข้อมูล/เอกสารอ้างอิงที่แสดงถึงศักยภาพทางวิชาการที่พร้อมให้บริการ
            </div>
            <Wysiwyg
                theme="3"
                :value="form.reference"
                @onChange="setFormField('reference', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </div>
    </divcard>
    <!-- 5. แนวความคิด (new initiative) ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต -->
    <divcard v-else>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            5. แนวความคิด (new initiative) ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  :value="form.initiative_idea"
                  @onChange="setFormField('initiative_idea', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>

    </divcard>

    <!-- 6. ผลการดำเนินงานที่ผ่านมา -->
    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            6. ผลการดำเนินงานที่ผ่านมา
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนวทางที่จะปรับปรุงและพัฒนาการให้บริการโดยประเมินจากการดำเนินงานที่ผ่านมา
              </div>
              <TextArea
                  theme="3"
                  :value="form.past_improvement"
                  @onChange="setFormField('past_improvement', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              การบริหารจัดการในการพัฒนาศักยภาพและการให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม ในปีงบประมาณที่ผ่านมา
            </div>
            <TextArea
                theme="3"
                :value="form.past_management"
                @onChange="setFormField('past_management', $event)"
            ></TextArea>
          </div>
        </div>
      </div>

      <div class="card-part">
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">
              ผลการดำเนินงานในการพัฒนาศักยภาพและการให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม
            </div>
            <TextArea
                theme="3"
                :value="form.past_performance"
                @onChange="setFormField('past_performance', $event)"
            ></TextArea>
          </div>
        </div>
      </div>

    </divcard>
    <!-- 6. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย -->
    <divcard v-else>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            6. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  :value="form.industrial_target"
                  @onChange="setFormField('industrial_target', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>

    </divcard>

    <!-- 7. แนวความคิด (new initiative) ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต -->
    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            7. แนวความคิด (new initiative) ในการพัฒนาเพื่อให้บริการการกับภาคอุตสาหกรรมต่อไปในอนาคต
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  :value="form.initiative_idea"
                  @onChange="setFormField('initiative_idea', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>

    </divcard>
    <!-- 7. เป้าหมาย -->
    <divcard v-else>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            7. เป้าหมาย
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  :value="form.target"
                  @onChange="setFormField('target', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>

    </divcard>

    <!-- 8. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย -->
    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            8. กลุ่มอุตสาหกรรมที่มุ่งเน้นและอุตสาหกรรมเป้าหมาย
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  :value="form.industrial_target"
                  @onChange="setFormField('industrial_target', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>

    </divcard>
    <!-- 8. การดำเนินงานและผลการดำเนินงานแผนงานการพัฒนาบริการของอุทยานวิทยาศาสตร์ -->
    <divcard v-else>

      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            8. การดำเนินงานและผลการดำเนินงานแผนงานการพัฒนาบริการของอุทยานวิทยาศาสตร์
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                การพัฒนาศักยภาพและให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_overview"
                        @onChange="
                      setFormField('pd_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_needs"
                        @onChange="
                      setFormField('pd_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_marketing"
                        @onChange="
                      setFormField('pd_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_readiness"
                        @onChange="
                      setFormField('pd_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_organization"
                        @onChange="
                      setFormField('pd_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_facilities"
                        @onChange="
                      setFormField('pd_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_service_process"
                        @onChange="
                      setFormField('pd_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_connection"
                        @onChange="
                      setFormField('pd_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_experts"
                        @onChange="
                      setFormField('pd_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_performance"
                        @onChange="
                      setFormField('pd_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_kpi"
                        @onChange="
                      setFormField('pd_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_results"
                        @onChange="
                      setFormField('pd_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- บริการออกแบบนวัตกรรม -->
      <div class="card-part pt-0">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text py-10">
                บริการออกแบบนวัตกรรม
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_overview"
                        @onChange="
                      setFormField('ds_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_needs"
                        @onChange="
                      setFormField('ds_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_marketing"
                        @onChange="
                      setFormField('ds_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_readiness"
                        @onChange="
                      setFormField('ds_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_organization"
                        @onChange="
                      setFormField('ds_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_facilities"
                        @onChange="
                      setFormField('ds_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_service_process"
                        @onChange="
                      setFormField('ds_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_connection"
                        @onChange="
                      setFormField('ds_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_experts"
                        @onChange="
                      setFormField('ds_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_performance"
                        @onChange="
                      setFormField('ds_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_kpi"
                        @onChange="
                      setFormField('ds_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_results"
                        @onChange="
                      setFormField('ds_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- การบริหารจัดการทรัพย์สินทางปัญญาแก่ภาคอุตสาหกรรม -->
      <div class="card-part pt-0">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text py-10  ">
                การบริหารจัดการทรัพย์สินทางปัญญาแก่ภาคอุตสาหกรรม
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_overview"
                        @onChange="
                      setFormField('ip_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_needs"
                        @onChange="
                      setFormField('ip_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_marketing"
                        @onChange="
                      setFormField('ip_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_readiness"
                        @onChange="
                      setFormField('ip_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_organization"
                        @onChange="
                      setFormField('ip_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_facilities"
                        @onChange="
                      setFormField('ip_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_service_process"
                        @onChange="
                      setFormField('ip_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_connection"
                        @onChange="
                      setFormField('ip_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_experts"
                        @onChange="
                      setFormField('ip_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_performance"
                        @onChange="
                      setFormField('ip_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_kpi"
                        @onChange="
                      setFormField('ip_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_results"
                        @onChange="
                      setFormField('ip_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- ฐานข้อมูลโครงสร้างพื้นฐานภาครัฐด้านวิทยาศาสตร์และเทคโนโลยี (Science and Technology Infrastructure Databank : STDB -->
      <div class="card-part pt-0">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text py-10">
                ฐานข้อมูลโครงสร้างพื้นฐานภาครัฐด้านวิทยาศาสตร์และเทคโนโลยี (Science and Technology Infrastructure
                Databank : STDB)
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_overview"
                        @onChange="
                      setFormField('stdb_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_needs"
                        @onChange="
                      setFormField('stdb_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_marketing"
                        @onChange="
                      setFormField('stdb_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_readiness"
                        @onChange="
                      setFormField('stdb_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_organization"
                        @onChange="
                      setFormField('stdb_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_facilities"
                        @onChange="
                      setFormField('stdb_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_service_process"
                        @onChange="
                      setFormField('stdb_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_connection"
                        @onChange="
                      setFormField('stdb_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_experts"
                        @onChange="
                      setFormField('stdb_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_performance"
                        @onChange="
                      setFormField('stdb_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_kpi"
                        @onChange="
                      setFormField('stdb_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_results"
                        @onChange="
                      setFormField('stdb_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- ข้อมูล/เอกสารอ้างอิงที่แสดงถึงศักยภาพทางวิชาการที่พร้อมให้บริการ -->
      <div class="card-part pt-0">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text py-10">
                ข้อมูล/เอกสารอ้างอิงที่แสดงถึงศักยภาพทางวิชาการที่พร้อมให้บริการ
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_overview"
                        @onChange="
                      setFormField('ref_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_needs"
                        @onChange="
                      setFormField('ref_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_marketing"
                        @onChange="
                      setFormField('ref_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_readiness"
                        @onChange="
                      setFormField('ref_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_organization"
                        @onChange="
                      setFormField('ref_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_facilities"
                        @onChange="
                      setFormField('ref_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_service_process"
                        @onChange="
                      setFormField('ref_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_connection"
                        @onChange="
                      setFormField('ref_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_experts"
                        @onChange="
                      setFormField('ref_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_performance"
                        @onChange="
                      setFormField('ref_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_kpi"
                        @onChange="
                      setFormField('ref_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_results"
                        @onChange="
                      setFormField('ref_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </divcard>

    <!-- 9. เป้าหมาย -->
    <divcard v-if="!isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            9. เป้าหมาย
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <TextArea
                  theme="3"
                  :value="form.target"
                  @onChange="setFormField('target', $event)"
              ></TextArea>
            </div>
          </div>
        </div>
      </div>

    </divcard>
    <!-- 10. การดำเนินงานและผลการดำเนินงานแผนงานการพัฒนาบริการของอุทยานวิทยาศาสตร์ -->
    <divcard v-if="!isFinal">

      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-3">
            10. การดำเนินงานและผลการดำเนินงานแผนงานการพัฒนาบริการของอุทยานวิทยาศาสตร์
          </div>

          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text topic-text-custom">
               10.1 การพัฒนาศักยภาพและให้บริการห้องปฏิบัติการแก่ภาคอุตสาหกรรม
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_overview"
                        @onChange="
                      setFormField('pd_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_needs"
                        @onChange="
                      setFormField('pd_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_marketing"
                        @onChange="
                      setFormField('pd_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_readiness"
                        @onChange="
                      setFormField('pd_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_organization"
                        @onChange="
                      setFormField('pd_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_facilities"
                        @onChange="
                      setFormField('pd_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_service_process"
                        @onChange="
                      setFormField('pd_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_connection"
                        @onChange="
                      setFormField('pd_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_experts"
                        @onChange="
                      setFormField('pd_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_performance"
                        @onChange="
                      setFormField('pd_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_kpi"
                        @onChange="
                      setFormField('pd_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.pd_results"
                        @onChange="
                      setFormField('pd_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- บริการออกแบบนวัตกรรม -->
      <div class="card-part pt-0">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text py-10 topic-text-custom">
               10.2 บริการออกแบบนวัตกรรม
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_overview"
                        @onChange="
                      setFormField('ds_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_needs"
                        @onChange="
                      setFormField('ds_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_marketing"
                        @onChange="
                      setFormField('ds_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_readiness"
                        @onChange="
                      setFormField('ds_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_organization"
                        @onChange="
                      setFormField('ds_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_facilities"
                        @onChange="
                      setFormField('ds_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_service_process"
                        @onChange="
                      setFormField('ds_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_connection"
                        @onChange="
                      setFormField('ds_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_experts"
                        @onChange="
                      setFormField('ds_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_performance"
                        @onChange="
                      setFormField('ds_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_kpi"
                        @onChange="
                      setFormField('ds_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ds_results"
                        @onChange="
                      setFormField('ds_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- การบริหารจัดการทรัพย์สินทางปัญญาแก่ภาคอุตสาหกรรม -->
      <div class="card-part pt-0">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text py-10 topic-text-custom">
                10.3 การบริหารจัดการทรัพย์สินทางปัญญาแก่ภาคอุตสาหกรรม
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_overview"
                        @onChange="
                      setFormField('ip_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_needs"
                        @onChange="
                      setFormField('ip_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_marketing"
                        @onChange="
                      setFormField('ip_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_readiness"
                        @onChange="
                      setFormField('ip_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_organization"
                        @onChange="
                      setFormField('ip_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_facilities"
                        @onChange="
                      setFormField('ip_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_service_process"
                        @onChange="
                      setFormField('ip_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_connection"
                        @onChange="
                      setFormField('ip_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_experts"
                        @onChange="
                      setFormField('ip_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_performance"
                        @onChange="
                      setFormField('ip_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_kpi"
                        @onChange="
                      setFormField('ip_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ip_results"
                        @onChange="
                      setFormField('ip_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- ฐานข้อมูลโครงสร้างพื้นฐานภาครัฐด้านวิทยาศาสตร์และเทคโนโลยี (Science and Technology Infrastructure Databank : STDB -->
      <div class="card-part pt-0">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text py-10 topic-text-custom">
               10.4 National Science and Technology Information System (NSTIS)
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_overview"
                        @onChange="
                      setFormField('stdb_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_needs"
                        @onChange="
                      setFormField('stdb_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_marketing"
                        @onChange="
                      setFormField('stdb_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_readiness"
                        @onChange="
                      setFormField('stdb_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_organization"
                        @onChange="
                      setFormField('stdb_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_facilities"
                        @onChange="
                      setFormField('stdb_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_service_process"
                        @onChange="
                      setFormField('stdb_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_connection"
                        @onChange="
                      setFormField('stdb_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_experts"
                        @onChange="
                      setFormField('stdb_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_performance"
                        @onChange="
                      setFormField('stdb_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_kpi"
                        @onChange="
                      setFormField('stdb_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.stdb_results"
                        @onChange="
                      setFormField('stdb_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- ความร่วมมืออุตสาหกรรม -->
      <div class="card-part pt-0">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text py-10 topic-text-custom">
               10.5 ความร่วมมืออุตสาหกรรม
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_overview"
                        @onChange="
                      setFormField('ic_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_needs"
                        @onChange="
                      setFormField('ic_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_marketing"
                        @onChange="
                      setFormField('ic_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_readiness"
                        @onChange="
                      setFormField('ic_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_organization"
                        @onChange="
                      setFormField('ic_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_facilities"
                        @onChange="
                      setFormField('ic_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_service_process"
                        @onChange="
                      setFormField('ic_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_connection"
                        @onChange="
                      setFormField('ic_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_experts"
                        @onChange="
                      setFormField('ic_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_performance"
                        @onChange="
                      setFormField('ic_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_kpi"
                        @onChange="
                      setFormField('ic_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ic_results"
                        @onChange="
                      setFormField('ic_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
      </div>



      <!-- ข้อมูล/เอกสารอ้างอิงที่แสดงถึงศักยภาพทางวิชาการที่พร้อมให้บริการ -->
      <div class="card-part pt-0">
        <div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text py-10 topic-text-custom">
               10.6 ข้อมูล/เอกสารอ้างอิงที่แสดงถึงศักยภาพทางวิชาการที่พร้อมให้บริการ
              </div>
              <ul class="pl-16">
                <li>
                  <div>
                    <div class="black--text mb-3">
                      ภาพรวมของกิจกรรม
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_overview"
                        @onChange="
                      setFormField('ref_overview', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ความต้องการของภาคเอกชนในการใช้บริการ พร้อมระบุตัวอย่างผู้สนใจใช้บริการ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_needs"
                        @onChange="
                      setFormField('ref_needs', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      วิธีการหาลูกค้า/การเจาะกลุ่มลูกค้าเป้าหมาย (PR & Marketing)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_marketing"
                        @onChange="
                      setFormField('ref_marketing', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ศักยภาพและความพร้อมในการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_readiness"
                        @onChange="
                      setFormField('ref_readiness', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      องค์กรและบุคลากร พร้อมแนวทางการพัฒนา
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_organization"
                        @onChange="
                      setFormField('ref_organization', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      โครงสร้างพื้นฐานและสิ่งอำนวยความสะดวกต่างๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_facilities"
                        @onChange="
                      setFormField('ref_facilities', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      กระบวนการให้บริการลูกค้า
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_service_process"
                        @onChange="
                      setFormField('ref_service_process', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      เครือข่าย ความเชื่อมโยงกับหน่วยงานและบริการอื่นๆ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_connection"
                        @onChange="
                      setFormField('ref_connection', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผู้เชี่ยวชาญและองค์ความรู้ที่สนับสนุนการดำเนินงาน (ถ้ามี)
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_experts"
                        @onChange="
                      setFormField('ref_experts', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลการดำเนินงาน
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_performance"
                        @onChange="
                      setFormField('ref_performance', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลผลิตและตัวชี้วัดความสำเร็จ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_kpi"
                        @onChange="
                      setFormField('ref_kpi', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="black--text mb-3 mt-5">
                      ผลลัพธ์และผลกระทบ
                    </div>
                    <Wysiwyg
                        theme="3"
                        :value="form.ref_results"
                        @onChange="
                      setFormField('ref_results', $event)
                    "
                    ></Wysiwyg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </divcard>

  </div>
</template>

<script>
import TextField from "../../../../components/input/TextField"
import TextArea from "../../../../components/input/TextArea"
import SwitchInset from "../../../../components/input/SwitchInset"
import AutoBox from "../../../../components/input/AutoBox"
import {eventBus, formatNumber} from "../../../../plugins/global-funcs"
import {mapState} from "vuex"
import Wysiwyg from "@/components/input/Wysiwyg.vue";

export default {
  name: "CFormProject_SP",
  components: {
    Wysiwyg,
    TextField,
    TextArea,
    SwitchInset,
    AutoBox
  },
  props: {
    masterData: {
      default: () => ({})
    },
    isSameId: {
      default: false
    }
  },
  data() {
    return {
      formatNumber,
      form: {},
    }
  },
  computed: {
    ...mapState({
      ProjectForm: state => state.CForm.ProjectForm,
      GeneralForm: state => state.CForm.GeneralForm
    }),
    isFinal() {
      return this.$route.query.doc_type && this.$route.query.doc_type === 'progress'
    }
  },
  created() {
    if (this.isSameId && !this.masterData.form_c) this.form = this.ProjectForm
    if (this.masterData.form_c) {
      this.form = this.masterData.form_c.project_section
    }
    eventBus.$on('cFormProject', () => {
      eventBus.$emit('cFormProjectSend', this.form)
    })

  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val
      this.$forceUpdate()
    },
  }
}
</script>

<style scoped>
.topic-text-custom{
  font-size: 18px;
  font-weight: 600;
}
</style>